module.exports = __webpack_public_path__ + "static/media/GTCJ.3d164424.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/GTCJ.jpg
// module id = 1750
// module chunks = 1